export class AdminApiEndpoint {
    public static Location = "api/location";
}

export class AuthControllerEndpoint{
    public static GraphTokenOBOEndpoint="api/auth/getgraphtokenobo";
    public static GetBotUserLoginStateEndpoint="api/auth/getuserloginstate";
    public static ValidateTeamsSSOTokenEndpoint="api/auth/validateToken";
    public static updateUserLoginStateInStorageEndpoint="api/auth/updateuserloginstate"
}

export class EnterpriseEndpoint {
    public static GetPendo="webapi/minisync/pendofeatures";
}